import React from "react";
import Services from "../components/Services/Services";
import Banner from "../components/Banner";


export const serviceDetails = [
  {
    "heading": "Trade Nexus",
    "id": "NTN",
    "description": "A product designed for short-term investors who are looking for a passive investment strategy. It follows the Classic Value Investing Strategy by identifying undervalued stocks, holding them for the long term, and delivering meaningful results over time.",
    "src": "",
    "prices": [
      { "weekly": null },
      { "monthly": "14999/-" },
      { "quarterly": "41000/-" },
      { "halfYearly": null },
      { "yearly": null }
    ],
    "features": [
      "Positional research report in the Equity Cash Segment.",
      "5-6 stocks with mispriced opportunity based on value investing.",
      "Holding period can be 6 months to 12 months.",
      "Quarterly updates via communication channels.",
      "Portfolio rebalancing applied as required based on market conditions."
    ],
    "investmentRules": [
      "Always invest with equal amounts; avoid concentrating all funds in one stock.",
      "Don't average down in any stock; this increases risk.",
      "Avoid emotional trading; take profits when available and don't panic during downturns.",
      "Focus on quality trades and avoid overtrading.",
      "Only trade with spare capital, avoiding loans or borrowed money.",
      "Stock market investments should not be a primary income source due to inherent risks."
    ],
    "callPattern": null,
    "note": null
  },
  {
    "heading": "Wealth Wave",
    "id": "NWW",
    "description": "A product designed for medium to long-term investors aiming to outperform index returns. Our analysts use a blend of fundamental and technical analysis to identify high-growth stocks, providing an opportunity for significant portfolio appreciation.",
    "src": "",
    "prices": [
      { "weekly": null },
      { "monthly": null },
      { "quarterly": "31000/-" },
      { "halfYearly": null },
      { "yearly": "70000/-" }
    ],
    "features": [
      "Invest in a personalized stock basket of 20-25 stocks.",
      "Combination of mid-cap and large-cap stocks.",
      "Stock selection based on strong past performance for diverse terms (short, medium, and long-term).",
      "Quarterly updates via communication channels.",
      "Continuous monitoring and portfolio adjustments based on market scenarios."
    ],
    "investmentRules": [],
    "callPattern": null,
    "note": null
  },
  {
    "heading": "Cash MIS",
    "id": "NCM",
    "description": "Cash MIS provides precise intraday stock recommendations in the cash segment, ensuring reliable insights for daily trades. Delivered via WhatsApp/SMS with follow-up support, it simplifies trading with clear guidance.",
    "src": "",
    "prices": [
      { "weekly": null },
      { "monthly": "14999/-" },
      { "quarterly": "41000/-" },
      { "halfYearly": null },
      { "yearly": null }
    ],
    "features": [
      "Only Cash Segment Intraday recommendations in Stocks.",
      "Total Recommendations – daily 2-3",
      "Service Mode- WHATSAPP/SMS",
      "Follow-Up- Yes"
    ],
    "investmentRules": [],
    "callPattern": [
      "BUY POWERGRID CASH Above 260 WITH SL OF 250 TGT 280-290",
      "The securities quoted are for illustration only and are not recommendatory."
    ],
    "note": ""
  },
  {
    "heading": "Stock Option MIS Pack",
    "id": "NSOM",
    "description": "Designed for traders interested in options call and put, leveraging options Greeks for informed decisions. Provides intraday and positional tips for trading stock options effectively.",
    "src": "",
    "prices": [
      { "weekly": "6000/-" },
      { "monthly": null },
      { "quarterly": "35500/-" },
      { "halfYearly": null },
      { "yearly": null }
    ],
    "features": [
      "Only Options Buying recommendations.",
      "Intraday/Positional recommendations in Stocks Options.",
      "Total Recommendations – 2-3 Daily.",
      "Service Mode- SMS.",
      "Follow-Up- Yes."
    ],
    "investmentRules": [],
    "callPattern": [
      "BUY TITAN 3600 AUGUST CE ABOVE 60 SL 50 TGT 70-80 LOT SIZE 175.",
      "The securities quoted are for illustration only and are not recommendatory."
    ],
    "note": ""
  },
  {
    "heading": "Index Option MIS Pack",
    "id": "NIOM",
    "description": "Specially tailored for traders focusing on Bank Nifty and Nifty Future and Options. Provides actionable insights leveraging options Greeks for intraday and positional strategies.",
    "src": "",
    "prices": [
      { "weekly": "7000/-" },
      { "monthly": null },
      { "quarterly": "35500/-" },
      { "halfYearly": null },
      { "yearly": null }
    ],
    "features": [
      "Only Options Buying recommendations.",
      "Intraday/Positional recommendations in Index Options.",
      "Intraday/Positional recommendations in Index Futures.",
      "Recommendations – 2-3 daily.",
      "Service Mode- SMS.",
      "Follow-Up- Yes."
    ],
    "investmentRules": [],
    "callPattern": [
      "BUY BANKNIFTY 26 MAY 36800 PE @455-460 TARGET 600 SL 300."
    ],
    "note": ""
  },
  {
    "heading": "Commodity Pack (Base Metal & Energy)",
    "id": "NCMP",
    "description": "Ideal for traders looking to engage in the commodity market with intraday and short-term strategies. Offers precise recommendations for MCX commodities.",
    "src": "",
    "prices": [
      { "weekly": null },
      { "monthly": "14999/-" },
      { "quarterly": "39500/-" },
      { "halfYearly": null },
      { "yearly": null }
    ],
    "features": [
      "Intraday-based recommendation in MCX commodity for Base Metals and Natural Gas.",
      "Recommendation Frequency- 20-22 monthly.",
      "Mode of recommendation- SMS.",
      "Follow-Up- Yes."
    ],
    "investmentRules": [],
    "callPattern": [
      "BUY 1 LOT OF ZINC MCX JAN FUTS IN THE RANGE OF 212.50-212.20 WITH THE SL OF 211.80 TGT 213.20."
    ],
    "note": ""
  },
  {
    "heading": "MCX Pack",
    "id": "NMCX",
    "description": "Designed for traders aiming for high-potential trades in MCX commodities. Provides daily recommendations for precious metals, base metals, and natural gas.",
    "src": "",
    "prices": [
      { "weekly": "12000/-" },
      { "monthly": null },
      { "quarterly": "37000/-" },
      { "halfYearly": null },
      { "yearly": null }
    ],
    "features": [
      "Intraday-based recommendation in MCX commodities.",
      "Recommendation Frequency- 1-2 Trades Daily.",
      "Mode of recommendation- SMS.",
      "Follow-Up- Yes."
    ],
    "investmentRules": [],
    "callPattern": [
      "BUY SILVER C MCX JAN FUTS IN THE RANGE OF 64000 WITH THE SL OF 211.80 TGT 213.20."
    ],
    "note": ""
  },
  {
    "heading": "Super Sensex",
    "id": "SSX",
    "description": "Super Sensex is a high-value recommendation service designed exclusively for traders focusing on Sensex options. You receive 1 expert-curated recommendation daily, helping you capture opportunities in the index options segment with confidence.",
    "src": "",
    "prices": [
      { "weekly": null },
      { "monthly": null },
      { "quarterly": null },
      { "halfYearly": "1,11,000" },
      { "yearly": null }
    ],
    "features": [
      "Daily 1 Recommendations in Sensex Option",
      "Whom: Traders who want to trade in Sensex options exclusively",
      "Ideal for : Retail traders who want to trade in options ",
      "Service Delivery: In a month, you get 20-25 recommendations in Sensex",
      " Risk Suitability: High",
      "Minimum investment : 1.50 Lakh",
      "Follow up: yes",
      "Medium of Recommendation : SMS and WhatsApp Support / API",
      "This service is available upon request only"
    ],
    "investmentRules": [],
    "callPattern": [
      "INDEX OPTION CALL: BUY SENSEX 84500 CE BETWEEN 400-410 TGT1 500 TGT2 700 SL 300"
    ],
    "note": "The maximum duration of this product is 6 months. Once the 6 months is completed, the client cannot renew the service until 12 months have passed since the start of the service."
  },
];
const ServicesPage = () => {
  return (
    <>
      <Services serviceDetails={serviceDetails} />
      <Banner />
    </>
  );
};

export default ServicesPage;
